export default __webpack_public_path__ + "static/media/nubladooscuro.bef78a12.gif";